// Exports the "noneditable" plugin for usage with module loaders
// Usage:
//   CommonJS:
//     require('tinymce/plugins/noneditable')
//   ES2015:
//     import 'tinymce/plugins/noneditable'
require('./plugin.js');


// WEBPACK FOOTER //
// ./src/packages/tinymce/plugins/noneditable/index.js